import * as cmMessageProperties from '../../consts/communicationLayer/cmMessageProperties';
import * as cmMessageTypes from '../../consts/communicationLayer/cmMessageTypes';
import {selectIsDeviceInSblMode, selectIsFirmwareStarted} from '../../state/selectors/iotDevice';
import {makeSelectRequestActionTypeData} from '../../state/selectors/yapEncrypted';
import {getState} from '../../state/store';
import arrayUtils from '../../utils/arrayUtils';
import framesProcessingService from '../device/framesProcessingService';
import mwMessageRequestService from '../iot/mwMessageRequestService';

let cyclicFramesData = {};

const resetCyclicFrames = () => {
    cyclicFramesData = {};
};

const isWriteFramesAllowed = () => {
    const state = getState();
    const isDeviceInSblMode = selectIsDeviceInSblMode(state);
    const isAllowed = selectIsFirmwareStarted(state) || isDeviceInSblMode;

    return !isAllowed;
};

const writeFrameCyclic = ({
    type,
    frames,
    request_id,
    processImmediately,
    transfer_data,
    cyclicId,
    cyclicTimeout,
    token,
    maxIterations,
    isResponseCheckNeeded,
}) => {
    const id = cyclicId ? cyclicId : type;
    const addCyclicFramesToQueue = () => {
        const isAllowed = isWriteFramesAllowed();

        if (type === cmMessageTypes.CYCLE_REQUESTS) {
            const isIterationLimit = cyclicFramesData[id].iterationNumber > cyclicFramesData[id].maxIterations;

            if (isIterationLimit) {
                cyclicFramesData[id] = null;
            } else if (cyclicId === cmMessageProperties.CYCLE_FRAME) {
                const {newValue: uamCleaningDeviceFinishedData} = makeSelectRequestActionTypeData()(getState());

                if (uamCleaningDeviceFinishedData) {
                    cyclicFramesData[id] = null;
                }
            }
        }

        if (isAllowed) {
            framesProcessingService.addFramesToQueue({
                frames,
                processImmediately,
                onSuccess: onSuccessResponse,
                onError: () => {
                    resetCyclicFrames();
                    mwMessageRequestService.publishCyclicErrorEvent({
                        type,
                        request_id,
                        transfer_data,
                    });
                },
            });
        } else {
            setCyclicTimeout();
        }
    };

    if (cyclicFramesData[id]) {
        clearTimeout(cyclicFramesData[id].timeout);
    }

    cyclicFramesData[id] = {};

    if (maxIterations) {
        cyclicFramesData[id].maxIterations = maxIterations;
        cyclicFramesData[id].iterationNumber = 0;
    }

    const setCyclicTimeout = () => {
        if (cyclicFramesData[id]) {
            cyclicFramesData[id].timeout = setTimeout(() => {
                if (cyclicFramesData[id]) {
                    addCyclicFramesToQueue();
                }
            }, cyclicTimeout);
        }
    };
    const onSuccessResponse = (responses) => {
        if (!cyclicFramesData[id]) return;

        const isCurrentEqualToPreviousResponse = isResponseCheckNeeded
            ? false
            : arrayUtils.equals(cyclicFramesData[id].currentResponse, responses);

        if (!isCurrentEqualToPreviousResponse) {
            cyclicFramesData[id].currentResponse = responses;

            if (cyclicFramesData[id].maxIterations) {
                cyclicFramesData[id].iterationNumber++;
            }

            mwMessageRequestService.publishResponseEvent({
                type,
                request_id,
                frames: responses,
                cyclicId,
                token,
                iterationNumber: cyclicFramesData[id].iterationNumber,
            });
        }

        setCyclicTimeout();
    };

    addCyclicFramesToQueue();
};

export default {
    resetCyclicFrames,
    writeFrameCyclic,
};
